module.exports = __webpack_public_path__ + "public/images/shedule-kam.ce6619f3a358cf1fbffe00f47e8dea95.png";